module.exports = __webpack_public_path__ + "static/media/SWTH.6cfeea2f.svg";